import { combineReducers } from '@reduxjs/toolkit';
import booking from './booking';
import theme from './theme';
import paymentBeam from "./paymentGateway/paymentBeam";
import hotelProfile from './hotelProfile';
import auth from './auth';
import hotelProfileConfig from './admin/hotelProfileConfig';
import roomDetailConfig from './admin/roomDetailConfig';
import rateDetailConfig from './admin/rateDetailConfig';
import hotelList from './admin/hotelList';

const rootReducer = combineReducers({ booking, theme, paymentBeam, hotelProfile, auth, hotelProfileConfig, roomDetailConfig, rateDetailConfig, hotelList });

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
